<template>
  <div class="gray-back" style="height: 100%">
      {{last_count}}/{{total}}
      <!-- {{list}} -->
  </div>
</template>
<style scoped> 
</style>
<script>
import Vue from 'vue';

import {
  Cell,
  Field,
  Tag,
  CellGroup,
  Stepper,
  Toast,
  Button,
    Switch,
  NumberKeyboard
} from 'vant';

export default {
  name: 'CommonLogin',
  components: { 
  },
  data: function () {
    return { 
      list:[],
      total:3322*3,
      last_count:0,
      index:0,
    }
  },
  filters: {},
  mounted() {
    let that = this;
    // that.formData.id = that.$route.query.id
    // this.fetch();
    
    document.title="队伍证书上云"
    that.getList() 
    setTimeout(() =>{
      window.location.reload()
    },300000)
  },
  watch: { 
  },
  destroyed() {
  },
  methods: {

    upCert(){
      let that =this
      // return 
      that.$api.get(that.list[that.index], {}, (res) => { 
        console.log('upCert res',res) 
        that.last_count++
        that.index ++
        that.upCert()
      }, (res) => {  
        console.log('接口报错'); 
      })

    },
    getList() {
      let that = this;
      that.$api.post('/api/Dshequscore/getCerList', {}, (res) => { 
        console.log('getList res',res)
        that.list = res.data
        that.last_count = this.total -  this.list.length;
        that.upCert()
      }, (res) => { 
      })
    },

 
  }
}
</script>



// WEBPACK FOOTER //
// ScoreUpOss.vue?78cf7023